/* All feather icons -> https://github.com/michaelbazos/angular-feather#available-icons */

import {
    Activity,
    AlertCircle,
    AlertTriangle,
    Archive,
    ArrowLeft,
    ArrowRight,
    ArrowRightCircle,
    ArrowUpLeft,
    Award,
    BarChart,
    Bell,
    Book,
    Bookmark,
    BookOpen,
    Calendar,
    Check,
    CheckCircle,
    CheckSquare,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Circle,
    Clipboard,
    Clock,
    CloudRain,
    Code,
    Compass,
    Copy,
    CornerRightDown,
    CreditCard,
    Database,
    DollarSign,
    Download,
    Droplet,
    Edit,
    Edit2,
    Edit3,
    ExternalLink,
    Eye,
    EyeOff,
    Feather,
    File,
    FileText,
    Film,
    Filter,
    Flag,
    Gift,
    Globe,
    Grid,
    Heart,
    HelpCircle,
    Home,
    Info,
    Layers,
    Layout,
    LifeBuoy,
    Link,
    List,
    Lock,
    LogOut,
    Mail,
    Map,
    MapPin,
    Maximize,
    Menu,
    MessageCircle,
    Minus,
    MinusCircle,
    Monitor,
    Moon,
    MoreHorizontal,
    MoreVertical,
    MousePointer,
    Package,
    // Fina Pago (handoff de diseño): tarifa, verificación, compartir enlace y pago móvil.
    Percent,
    PieChart,
    PlayCircle,
    Plus,
    PlusCircle,
    Printer,
    RefreshCw,
    Repeat,
    RotateCcw,
    Search,
    Send,
    Settings,
    Share,
    Share2,
    Shield,
    ShoppingCart,
    Sidebar,
    Sliders,
    Smartphone,
    Sun,
    Sunset,
    Tag,
    ThumbsDown,
    ThumbsUp,
    Tool,
    Trash2,
    TrendingDown,
    TrendingUp,
    Type,
    Upload,
    UploadCloud,
    User,
    UserPlus,
    Users,
    WifiOff,
    X,
    XCircle,
    Zap,
    ZapOff,
} from 'angular-feather/icons';

export const featherIcons = {
    Activity,
    AlertTriangle,
    AlertCircle,
    Archive,
    ArrowUpLeft,
    BarChart,
    Award,
    ArrowLeft,
    ArrowRight,
    ArrowRightCircle,
    Bell,
    Book,
    Bookmark,
    BookOpen,
    Calendar,
    Check,
    CheckCircle,
    CheckSquare,
    ChevronUp,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    Circle,
    Clock,
    Clipboard,
    CloudRain,
    Code,
    Compass,
    Copy,
    CornerRightDown,
    CreditCard,
    Database,
    DollarSign,
    Download,
    Droplet,
    Edit,
    Edit2,
    Edit3,
    ExternalLink,
    Eye,
    EyeOff,
    Feather,
    File,
    FileText,
    Film,
    Filter,
    Flag,
    Gift,
    Globe,
    Grid,
    Heart,
    HelpCircle,
    Home,
    Info,
    Layers,
    Layout,
    LifeBuoy,
    Link,
    List,
    Lock,
    LogOut,
    Mail,
    Map,
    MapPin,
    Maximize,
    Menu,
    MessageCircle,
    Minus,
    MinusCircle,
    Monitor,
    Moon,
    MoreHorizontal,
    MoreVertical,
    MousePointer,
    Package,
    PieChart,
    PlayCircle,
    Plus,
    PlusCircle,
    Printer,
    RefreshCw,
    RotateCcw,
    Repeat,
    Search,
    Send,
    Settings,
    Share,
    ShoppingCart,
    Sidebar,
    Smartphone,
    Sliders,
    Sun,
    Sunset,
    Tag,
    Tool,
    ThumbsDown,
    ThumbsUp,
    Trash2,
    TrendingDown,
    TrendingUp,
    Type,
    Upload,
    UploadCloud,
    User,
    UserPlus,
    Users,
    WifiOff,
    X,
    XCircle,
    Zap,
    ZapOff,
    Percent,
    Shield,
    Share2,
};
